export default function CsFirewalls() {
  return (
    <h2>Cs Firewalls</h2>
  );
}
